import * as _ from "lodash";
import me from "models/me";
import { BrandRecord } from "records/brand/brand";
import { IItemRecord, IProduct } from "records/item/item";
import { InventoryType } from "constants/inventory-types";
import { getTotal } from "helpers/inventory";

/**
 * Check if product has valid inventory.
 * @param {IItemRecord} product - product item
 * @return {boolean} inventory exists
 */

export function hasInventory(product: Partial<IProduct>) {
    return !!product && product.__tracks_inventory && product.__inventory.some((item) => item !== "Pre-book");
}

export function hasInventoryOfType(product: IItemRecord, inventoryType: InventoryType) {
    return _.includes(product?.__inventory, inventoryType);
}

/**
 * Calculate total inventory according to inventory list and brand limits.
 * @param {number[]} list - a list of quantities
 * @param {BrandRecord} brand - brand data to get limits
 * @return {string | number} total inventory (could be a string as 100+)
 */
export function getTotalInventory(list: number[], brand: BrandRecord): string | number {
    const upLimit =
        (_.get(brand, ["_brandConnection", "hide_full_inventory"]) || me.account_type === "buyer") &&
        brand.hasPreference("inventory_maximum_threshold");
    return getTotal(list, { min: 0, max: upLimit });
}

/**
 * Indicates removal of zeros under inputs inside the immediate delivery window row.
 */
export const hideAtsZeros = (product: IItemRecord, brand: BrandRecord) => {
    const hasFutureOrPrebookInventory =
        hasInventoryOfType(product, InventoryType.Future) || hasInventoryOfType(product, InventoryType.Prebook);
    return brand?.hasPreference("remove_ats_zeroes_if_wip_or_prebook_exists") && hasFutureOrPrebookInventory;
};
